import { jsxs as f, Fragment as E, jsx as o } from "react/jsx-runtime";
import { useMemo as Be, useState as v, useRef as U, useEffect as ie, forwardRef as fe, createElement as le } from "react";
import { useQuery as ze, useQueryClient as We } from "@tanstack/react-query";
import Re from "react-dom";
const t = {
  // Primary colors
  primary: "#031425",
  white: "#fff",
  black: "#000",
  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",
  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",
  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",
  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",
  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",
  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",
  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)"
}, z = {
  THEME_ID: "bc_themeId",
  EDIT_MODE: "bc_editMode",
  EDIT_THEME_TOKEN: "bc_editThemeToken"
}, Le = (e, a, n) => {
  try {
    e ? localStorage.setItem(z.THEME_ID, e) : localStorage.removeItem(z.THEME_ID), localStorage.setItem(z.EDIT_MODE, String(a)), n ? localStorage.setItem(z.EDIT_THEME_TOKEN, n) : localStorage.removeItem(z.EDIT_THEME_TOKEN);
  } catch (r) {
    console.error("Failed to save theme params to localStorage:", r);
  }
}, De = () => {
  try {
    return {
      themeId: localStorage.getItem(z.THEME_ID),
      editMode: localStorage.getItem(z.EDIT_MODE) === "true",
      editThemeToken: localStorage.getItem(z.EDIT_THEME_TOKEN)
    };
  } catch (e) {
    return console.error("Failed to read theme params from localStorage:", e), {
      themeId: null,
      editMode: !1,
      editThemeToken: null
    };
  }
}, je = () => {
  try {
    localStorage.removeItem(z.THEME_ID), localStorage.removeItem(z.EDIT_MODE), localStorage.removeItem(z.EDIT_THEME_TOKEN);
  } catch (e) {
    console.error("Failed to clear theme params from localStorage:", e);
  }
}, Oe = () => {
  try {
    const e = new URLSearchParams(window.location.search), a = e.get("themeId"), n = e.get("editMode") === "true", r = e.get("editThemeToken");
    a && Le(a, n, r);
  } catch (e) {
    console.error("Failed to sync URL to storage:", e);
  }
}, Ae = () => {
  try {
    const e = new URL(window.location.href);
    e.searchParams.delete("themeId"), e.searchParams.delete("editMode"), e.searchParams.delete("editThemeToken"), window.history.replaceState({}, "", e.toString());
  } catch (e) {
    console.error("Failed to clear URL params:", e);
  }
}, vt = (e, a, n) => {
  try {
    const r = new URL(window.location.href);
    e ? (r.searchParams.set("themeId", e), r.searchParams.set("editMode", String(a)), n ? r.searchParams.set("editThemeToken", n) : r.searchParams.delete("editThemeToken")) : (r.searchParams.delete("themeId"), r.searchParams.delete("editMode"), r.searchParams.delete("editThemeToken")), window.history.replaceState({}, "", r.toString());
  } catch (r) {
    console.error("Failed to update URL params:", r);
  }
}, R = () => Be(() => {
  const e = new URLSearchParams(window.location.search), a = e.get("themeId"), n = e.get("editMode"), r = e.get("editThemeToken"), i = De();
  return {
    themeId: a || i.themeId,
    editMode: n === "true" || n === null && i.editMode,
    editThemeToken: r || i.editThemeToken
  };
}, []), He = () => {
  var e;
  return typeof window < "u" && ((e = window.location) != null && e.origin) ? `${window.location.origin}/api-rewards` : "https://localhost.brandclub.com/api-rewards";
}, W = He(), Ue = async (e) => {
  const a = await fetch(
    `${W}/brand-app-widget-theme/by-theme-id?appThemeId=${e}`
  );
  if (!a.ok)
    throw new Error("Failed to fetch widget theme");
  return a.json();
}, Ye = async (e) => {
  const a = await fetch(
    `${W}/brand-app-widget-theme/published-by-app-id?appId=${e}`
  );
  if (!a.ok)
    throw new Error("Failed to fetch published widget theme");
  return a.json();
}, K = async ({
  themeId: e,
  widgetId: a,
  widgetState: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${W}/brand-app-widget-theme/update-widget-config`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        widgetId: a,
        widgetState: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to update widget config";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, he = async ({
  themeId: e,
  colorKey: a,
  colorValue: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${W}/brand-app-widget-theme/set-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: a,
        colorValue: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme color";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, Ve = async ({
  themeId: e,
  colorKey: a,
  editThemeToken: n
}) => {
  const r = await fetch(
    `${W}/brand-app-widget-theme/delete-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: a,
        editThemeToken: n
      })
    }
  );
  if (!r.ok) {
    let i = "Failed to delete theme color";
    try {
      i = (await r.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return r.json();
}, ge = async ({
  themeId: e,
  fileName: a,
  contentType: n,
  assetType: r,
  editThemeToken: i
}) => {
  const l = await fetch(
    `${W}/brand-app-widget-theme/generate-asset-upload-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fileName: a,
        contentType: n,
        assetType: r,
        editThemeToken: i
      })
    }
  );
  if (!l.ok) {
    let c = "Failed to generate upload URL";
    try {
      const k = await l.json();
      c = k.errorMessage || k.message || c;
    } catch {
    }
    throw new Error(c);
  }
  const h = await l.json();
  if (h.status === "failed")
    throw new Error(h.errorMessage || "Failed to generate upload URL");
  return {
    signedUploadUrl: h.signedUploadUrl,
    objectPublicUrl: h.objectPublicUrl
  };
}, ue = async ({
  file: e,
  signedUploadUrl: a
}) => {
  if (!(await fetch(a, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  })).ok)
    throw new Error("Failed to upload file to S3");
}, Xe = async ({
  themeId: e,
  fontKey: a,
  fontValue: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${W}/brand-app-widget-theme/set-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: a,
        fontValue: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme font";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, qe = async ({
  themeId: e,
  fontKey: a,
  editThemeToken: n
}) => {
  const r = await fetch(
    `${W}/brand-app-widget-theme/delete-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: a,
        editThemeToken: n
      })
    }
  );
  if (!r.ok) {
    let i = "Failed to delete theme font";
    try {
      i = (await r.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return r.json();
}, Ke = async ({
  themeId: e,
  iconKey: a,
  iconValue: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${W}/brand-app-widget-theme/set-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: a,
        iconValue: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme icon";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, Je = async ({
  themeId: e,
  iconKey: a,
  editThemeToken: n
}) => {
  const r = await fetch(
    `${W}/brand-app-widget-theme/delete-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: a,
        editThemeToken: n
      })
    }
  );
  if (!r.ok) {
    let i = "Failed to delete theme icon";
    try {
      i = (await r.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return r.json();
}, se = ["bc-widget-theme"], te = () => {
  const e = R();
  return ze({
    queryKey: [...se, e.themeId],
    queryFn: async () => {
      if (e.themeId)
        return Ue(e.themeId);
      const a = window.location.hostname;
      return Ye(a);
    },
    staleTime: 5 * 60 * 1e3
    // 5 minutes
  });
}, Y = () => {
  var r;
  const { data: e, isLoading: a, refetch: n } = te();
  return {
    themeColors: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.colors) || {},
    isLoading: a,
    refreshThemeColors: async () => {
      await n();
    }
  };
}, de = () => {
  var r;
  const { data: e, isLoading: a, refetch: n } = te();
  return {
    themeFonts: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.fonts) || {},
    isLoading: a,
    refreshThemeFonts: async () => {
      await n();
    }
  };
}, xe = () => {
  var r;
  const { data: e, isLoading: a, refetch: n } = te();
  return {
    themeIcons: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.icons) || {},
    isLoading: a,
    refreshThemeIcons: async () => {
      await n();
    }
  };
}, J = (e, a) => {
  var l, h;
  const { data: n, isLoading: r } = te(), i = e ? (h = (l = n == null ? void 0 : n.config) == null ? void 0 : l.widgetConfig) == null ? void 0 : h[e] : void 0;
  return {
    ...a,
    ...i,
    isLoading: r
  };
}, G = (e) => {
  const a = We(), n = R();
  return { updateWidgetConfig: (l, h) => {
    e && a.setQueryData(
      [...se, n.themeId],
      (c) => {
        var k, g, u;
        return c ? {
          ...c,
          config: {
            ...c == null ? void 0 : c.config,
            widgetConfig: {
              ...(k = c == null ? void 0 : c.config) == null ? void 0 : k.widgetConfig,
              [e]: {
                ...(u = (g = c == null ? void 0 : c.config) == null ? void 0 : g.widgetConfig) == null ? void 0 : u[e],
                [l]: h
              }
            }
          }
        } : {
          config: {
            widgetConfig: {
              [e]: {
                [l]: h
              }
            }
          }
        };
      }
    );
  }, getWidgetState: () => {
    var h, c;
    if (!e) return;
    const l = a.getQueryData([
      ...se,
      n.themeId
    ]);
    return (c = (h = l == null ? void 0 : l.config) == null ? void 0 : h.widgetConfig) == null ? void 0 : c[e];
  } };
}, kt = () => {
  var pe;
  const e = R(), [a, n] = v({ x: 20, y: 20 }), [r, i] = v(!1), [l, h] = v({ x: 0, y: 0 }), c = U(null), [k, g] = v(!1), { themeColors: u, refreshThemeColors: I } = Y(), { themeFonts: _, refreshThemeFonts: $ } = de(), { themeIcons: M, refreshThemeIcons: y } = xe(), [w, x] = v(""), [N, L] = v("#000000"), [j, d] = v(!1), [p, F] = v(!1), [V, C] = v(null), [Z, T] = v(null), [ae, X] = v(!1), [B, m] = v(""), [S, q] = v(null), O = U(null), [we, oe] = v(!1), [A, ee] = v(""), [D, re] = v(null), H = U(null);
  if (ie(() => {
    Oe();
  }, []), !e.themeId)
    return null;
  const ve = (s) => {
    if (!(s.target instanceof HTMLButtonElement || s.target instanceof HTMLInputElement || s.target.closest("button")) && (i(!0), c.current)) {
      const b = c.current.getBoundingClientRect();
      h({
        x: s.clientX - b.left,
        y: s.clientY - b.top
      });
    }
  }, ce = (s) => {
    r && n({
      x: s.clientX - l.x,
      y: s.clientY - l.y
    });
  }, me = () => {
    i(!1);
  };
  ie(() => {
    if (r)
      return window.addEventListener("mousemove", ce), window.addEventListener("mouseup", me), () => {
        window.removeEventListener("mousemove", ce), window.removeEventListener("mouseup", me);
      };
  }, [r, l]);
  const ke = () => {
    je(), Ae(), window.location.reload();
  }, Te = () => {
    g(!k);
  }, Ce = async () => {
    if (!w.trim()) {
      C("Color name is required");
      return;
    }
    if (!e.editThemeToken || !e.themeId) {
      C("Theme ID and edit token are required");
      return;
    }
    F(!0), C(null), T(null);
    try {
      await he({
        themeId: e.themeId,
        colorKey: w.trim(),
        colorValue: N,
        editThemeToken: e.editThemeToken
      }), await I(), x(""), L("#000000"), d(!1), T("Color added successfully"), setTimeout(() => T(null), 2e3);
    } catch (s) {
      C(s.message || "Failed to add color");
    } finally {
      F(!1);
    }
  }, Se = async (s, b) => {
    if (!(!e.editThemeToken || !e.themeId)) {
      F(!0), C(null), T(null);
      try {
        await he({
          themeId: e.themeId,
          colorKey: s,
          colorValue: b,
          editThemeToken: e.editThemeToken
        }), await I(), T("Color updated successfully"), setTimeout(() => T(null), 2e3);
      } catch (P) {
        C(P.message || "Failed to update color");
      } finally {
        F(!1);
      }
    }
  }, Fe = async (s) => {
    if (!(!e.editThemeToken || !e.themeId) && window.confirm(`Delete color "${s}"?`)) {
      F(!0), C(null), T(null);
      try {
        await Ve({
          themeId: e.themeId,
          colorKey: s,
          editThemeToken: e.editThemeToken
        }), await I(), T("Color deleted successfully"), setTimeout(() => T(null), 2e3);
      } catch (b) {
        C(b.message || "Failed to delete color");
      } finally {
        F(!1);
      }
    }
  }, Ie = (s) => {
    var P;
    switch ((P = s.split(".").pop()) == null ? void 0 : P.toLowerCase()) {
      case "woff2":
        return "woff2";
      case "woff":
        return "woff";
      case "ttf":
        return "truetype";
      case "otf":
        return "opentype";
      default:
        return "woff2";
    }
  }, $e = (s) => {
    var P;
    const b = (P = s.target.files) == null ? void 0 : P[0];
    if (b && (q(b), !B)) {
      const ne = b.name.replace(/\.[^/.]+$/, "");
      m(ne);
    }
  }, _e = async () => {
    if (!B.trim() || !S) {
      C("Font name and file are required");
      return;
    }
    if (!e.editThemeToken || !e.themeId) {
      C("Theme ID and edit token are required");
      return;
    }
    F(!0), C(null), T(null);
    try {
      const { signedUploadUrl: s, objectPublicUrl: b } = await ge(
        {
          themeId: e.themeId,
          fileName: S.name,
          contentType: S.type || "font/woff2",
          assetType: "font",
          editThemeToken: e.editThemeToken
        }
      );
      await ue({
        file: S,
        signedUploadUrl: s
      }), await Xe({
        themeId: e.themeId,
        fontKey: B.trim(),
        fontValue: {
          name: B.trim(),
          url: b,
          format: Ie(S.name)
        },
        editThemeToken: e.editThemeToken
      }), await $(), m(""), q(null), X(!1), O.current && (O.current.value = ""), T("Font added successfully"), setTimeout(() => T(null), 2e3);
    } catch (s) {
      C(s.message || "Failed to add font");
    } finally {
      F(!1);
    }
  }, Me = async (s) => {
    if (!(!e.editThemeToken || !e.themeId) && window.confirm(`Delete font "${s}"?`)) {
      F(!0), C(null), T(null);
      try {
        await qe({
          themeId: e.themeId,
          fontKey: s,
          editThemeToken: e.editThemeToken
        }), await $(), T("Font deleted successfully"), setTimeout(() => T(null), 2e3);
      } catch (b) {
        C(b.message || "Failed to delete font");
      } finally {
        F(!1);
      }
    }
  }, Ne = (s) => {
    var P;
    const b = (P = s.target.files) == null ? void 0 : P[0];
    if (b && (re(b), !A)) {
      const ne = b.name.replace(/\.[^/.]+$/, "");
      ee(ne);
    }
  }, Ee = async () => {
    if (!A.trim() || !D) {
      C("Icon name and file are required");
      return;
    }
    if (!e.editThemeToken || !e.themeId) {
      C("Theme ID and edit token are required");
      return;
    }
    F(!0), C(null), T(null);
    try {
      const { signedUploadUrl: s, objectPublicUrl: b } = await ge(
        {
          themeId: e.themeId,
          fileName: D.name,
          contentType: D.type || "image/svg+xml",
          assetType: "icon",
          editThemeToken: e.editThemeToken
        }
      );
      await ue({
        file: D,
        signedUploadUrl: s
      }), await Ke({
        themeId: e.themeId,
        iconKey: A.trim(),
        iconValue: {
          name: A.trim(),
          url: b
        },
        editThemeToken: e.editThemeToken
      }), await y(), ee(""), re(null), oe(!1), H.current && (H.current.value = ""), T("Icon added successfully"), setTimeout(() => T(null), 2e3);
    } catch (s) {
      C(s.message || "Failed to add icon");
    } finally {
      F(!1);
    }
  }, Pe = async (s) => {
    if (!(!e.editThemeToken || !e.themeId) && window.confirm(`Delete icon "${s}"?`)) {
      F(!0), C(null), T(null);
      try {
        await Je({
          themeId: e.themeId,
          iconKey: s,
          editThemeToken: e.editThemeToken
        }), await y(), T("Icon deleted successfully"), setTimeout(() => T(null), 2e3);
      } catch (b) {
        C(b.message || "Failed to delete icon");
      } finally {
        F(!1);
      }
    }
  };
  return /* @__PURE__ */ f(E, { children: [
    /* @__PURE__ */ o("style", { children: `
        @keyframes bc-theme-manager-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .bc-theme-manager-bar {
          position: fixed;
          z-index: 999999;
          background: ${t.glass_bg};
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid ${t.border_subtle};
          border-radius: 16px;
          padding: 14px 20px;
          box-shadow: 
            0 4px 24px ${t.shadow_soft},
            0 8px 32px ${t.shadow_medium},
            0 0 0 1px ${t.border_glass};
          display: flex;
          align-items: center;
          gap: 16px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          user-select: none;
          cursor: ${r ? "grabbing" : "grab"};
          transition: box-shadow 0.2s ease, transform 0.15s ease;
        }

        .bc-theme-manager-bar:hover {
          box-shadow: 
            0 8px 32px ${t.shadow_medium},
            0 16px 48px ${t.shadow_soft},
            0 0 0 1px ${t.border_glass};
        }

        .bc-theme-manager-bar * {
          box-sizing: border-box;
        }

        .bc-theme-manager-label {
          font-size: 13px;
          font-weight: 600;
          color: ${t.gray_medium};
          display: flex;
          align-items: center;
          gap: 10px;
          letter-spacing: 0.3px;
        }

        .bc-theme-manager-theme-id {
          font-weight: 500;
          color: ${t.blue_dark};
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          font-size: 12px;
          background: ${t.overlay_light};
          padding: 6px 12px;
          border-radius: 8px;
          border: 1px solid ${t.border_glass};
        }

        .bc-theme-manager-divider {
          width: 1px;
          height: 28px;
          background: linear-gradient(
            to bottom,
            transparent,
            ${t.gray_border},
            transparent
          );
          opacity: 0.5;
        }

        .bc-theme-manager-exit-btn {
          background: linear-gradient(135deg, ${t.red} 0%, #e63e37 100%);
          color: ${t.white};
          border: none;
          border-radius: 10px;
          padding: 10px 18px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          outline: none;
          box-shadow: 0 2px 8px rgba(255, 83, 74, 0.25);
          letter-spacing: 0.2px;
        }

        .bc-theme-manager-exit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(255, 83, 74, 0.35);
        }

        .bc-theme-manager-exit-btn:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(255, 83, 74, 0.25);
        }

        .bc-theme-manager-drag-handle {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 3px;
          padding: 4px;
          cursor: grab;
          opacity: 0.4;
          transition: opacity 0.15s ease;
        }

        .bc-theme-manager-drag-handle:hover {
          opacity: 0.7;
        }

        .bc-theme-manager-drag-handle:active {
          cursor: grabbing;
          opacity: 1;
        }

        .bc-theme-manager-drag-dot {
          width: 4px;
          height: 4px;
          background: ${t.gray_medium};
          border-radius: 1px;
        }

        .bc-theme-manager-settings-btn {
          background: linear-gradient(135deg, ${t.blue} 0%, ${t.blue_dark} 100%);
          color: ${t.white};
          border: none;
          border-radius: 10px;
          padding: 10px 18px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          outline: none;
          box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
          letter-spacing: 0.2px;
        }

        .bc-theme-manager-settings-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
        }

        .bc-theme-manager-settings-btn:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
        }

        .bc-theme-manager-settings-panel {
          position: fixed;
          z-index: 999998;
          background: ${t.glass_bg_strong};
          backdrop-filter: blur(24px);
          -webkit-backdrop-filter: blur(24px);
          border: 1px solid ${t.border_subtle};
          border-radius: 20px;
          padding: 24px;
          box-shadow: 
            0 8px 40px ${t.shadow_medium},
            0 20px 60px ${t.shadow_soft},
            0 0 0 1px ${t.border_glass};
          min-width: 520px;
          max-width: 620px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          animation: bc-theme-manager-slideIn 0.2s ease-out;
        }

        .bc-theme-manager-message {
          padding: 12px 16px;
          border-radius: 12px;
          margin-bottom: 20px;
          font-size: 13px;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .bc-theme-manager-message-success {
          background: rgba(113, 194, 133, 0.15);
          color: ${t.green};
          border: 1px solid rgba(113, 194, 133, 0.3);
        }

        .bc-theme-manager-message-error {
          background: rgba(255, 83, 74, 0.1);
          color: ${t.red};
          border: 1px solid rgba(255, 83, 74, 0.2);
        }

        .bc-theme-manager-section {
          margin-bottom: 24px;
        }

        .bc-theme-manager-section:last-child {
          margin-bottom: 0;
        }

        .bc-theme-manager-section-title {
          font-size: 11px;
          font-weight: 700;
          color: ${t.gray_medium};
          text-transform: uppercase;
          letter-spacing: 1px;
          margin: 0 0 16px 0;
          padding-bottom: 12px;
          border-bottom: 1px solid ${t.border_glass};
        }

        .bc-theme-manager-loading {
          text-align: center;
          padding: 32px;
          color: ${t.gray_medium};
          font-size: 13px;
        }

        .bc-theme-manager-color-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .bc-theme-manager-color-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 14px 16px;
          background: ${t.overlay_light};
          border-radius: 14px;
          border: 1px solid ${t.border_glass};
          transition: all 0.15s ease;
        }

        .bc-theme-manager-color-row:hover {
          background: ${t.white};
          box-shadow: 0 2px 12px ${t.shadow_soft};
        }

        .bc-theme-manager-color-name {
          flex: 1;
          padding: 10px 14px;
          border: 1px solid ${t.border_glass};
          border-radius: 10px;
          font-size: 13px;
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          background: ${t.white};
          color: ${t.primary};
          outline: none;
          transition: all 0.15s ease;
        }

        .bc-theme-manager-color-name:focus {
          border-color: ${t.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
        }

        .bc-theme-manager-color-name:disabled {
          background: transparent;
          border-color: transparent;
          color: ${t.primary};
          cursor: default;
          padding-left: 0;
        }

        .bc-theme-manager-color-picker {
          width: 52px;
          height: 40px;
          border: 2px solid ${t.border_glass};
          border-radius: 10px;
          cursor: pointer;
          outline: none;
          padding: 2px;
          transition: all 0.15s ease;
        }

        .bc-theme-manager-color-picker:hover:not(:disabled) {
          border-color: ${t.gray_border};
          transform: scale(1.05);
        }

        .bc-theme-manager-color-picker:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }

        .bc-theme-manager-color-value {
          font-size: 12px;
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          color: ${t.gray_medium};
          min-width: 70px;
          background: ${t.bg_light};
          padding: 6px 10px;
          border-radius: 6px;
        }

        .bc-theme-manager-delete-btn,
        .bc-theme-manager-save-btn,
        .bc-theme-manager-cancel-btn {
          padding: 10px 16px;
          border: none;
          border-radius: 10px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.15s ease;
          outline: none;
          letter-spacing: 0.2px;
        }

        .bc-theme-manager-delete-btn {
          background: linear-gradient(135deg, ${t.red} 0%, #e63e37 100%);
          color: ${t.white};
          box-shadow: 0 2px 6px rgba(255, 83, 74, 0.2);
        }

        .bc-theme-manager-delete-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(255, 83, 74, 0.3);
        }

        .bc-theme-manager-save-btn {
          background: linear-gradient(135deg, ${t.green} 0%, #5fb077 100%);
          color: ${t.white};
          box-shadow: 0 2px 6px rgba(113, 194, 133, 0.2);
        }

        .bc-theme-manager-save-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(113, 194, 133, 0.3);
        }

        .bc-theme-manager-cancel-btn {
          background: ${t.gray_light};
          color: ${t.gray_dark};
        }

        .bc-theme-manager-cancel-btn:hover:not(:disabled) {
          background: ${t.gray_border};
        }

        .bc-theme-manager-delete-btn:disabled,
        .bc-theme-manager-save-btn:disabled,
        .bc-theme-manager-cancel-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
        }

        .bc-theme-manager-add-color-btn {
          width: fit-content;
          padding: 12px 20px;
          background: transparent;
          color: ${t.blue};
          border: 2px dashed ${t.gray_border};
          border-radius: 12px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.15s ease;
          outline: none;
          margin-top: 4px;
        }

        .bc-theme-manager-add-color-btn:hover:not(:disabled) {
          background: ${t.blue_light};
          border-color: ${t.blue};
          border-style: solid;
        }

        .bc-theme-manager-add-color-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .bc-theme-manager-asset-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 14px 16px;
          background: ${t.overlay_light};
          border-radius: 14px;
          border: 1px solid ${t.border_glass};
          transition: all 0.15s ease;
        }

        .bc-theme-manager-asset-row:hover {
          background: ${t.white};
          box-shadow: 0 2px 12px ${t.shadow_soft};
        }

        .bc-theme-manager-asset-name {
          flex: 1;
          padding: 10px 14px;
          border: 1px solid ${t.border_glass};
          border-radius: 10px;
          font-size: 13px;
          background: ${t.white};
          color: ${t.primary};
          outline: none;
          transition: all 0.15s ease;
        }

        .bc-theme-manager-asset-name:focus {
          border-color: ${t.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
        }

        .bc-theme-manager-asset-name:disabled {
          background: transparent;
          border-color: transparent;
          color: ${t.primary};
          cursor: default;
          padding-left: 0;
        }

        .bc-theme-manager-file-input-wrapper {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .bc-theme-manager-file-btn {
          padding: 8px 14px;
          background: ${t.overlay_light};
          border: 1px solid ${t.border_glass};
          border-radius: 8px;
          font-size: 12px;
          font-weight: 500;
          color: ${t.gray_dark};
          cursor: pointer;
          transition: all 0.15s ease;
        }

        .bc-theme-manager-file-btn:hover:not(:disabled) {
          background: ${t.white};
          border-color: ${t.blue};
          color: ${t.blue};
        }

        .bc-theme-manager-file-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .bc-theme-manager-file-name {
          font-size: 12px;
          color: ${t.gray_medium};
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .bc-theme-manager-asset-preview {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          background: ${t.bg_light};
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .bc-theme-manager-asset-preview img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        .bc-theme-manager-asset-format {
          font-size: 11px;
          color: ${t.gray_medium};
          background: ${t.bg_light};
          padding: 4px 8px;
          border-radius: 4px;
          text-transform: uppercase;
        }
      ` }),
    /* @__PURE__ */ f(
      "div",
      {
        ref: c,
        className: "bc-theme-manager-bar",
        style: {
          left: `${a.x}px`,
          top: `${a.y}px`
        },
        onMouseDown: ve,
        children: [
          /* @__PURE__ */ f("div", { className: "bc-theme-manager-drag-handle", children: [
            /* @__PURE__ */ o("div", { className: "bc-theme-manager-drag-dot" }),
            /* @__PURE__ */ o("div", { className: "bc-theme-manager-drag-dot" }),
            /* @__PURE__ */ o("div", { className: "bc-theme-manager-drag-dot" }),
            /* @__PURE__ */ o("div", { className: "bc-theme-manager-drag-dot" }),
            /* @__PURE__ */ o("div", { className: "bc-theme-manager-drag-dot" }),
            /* @__PURE__ */ o("div", { className: "bc-theme-manager-drag-dot" })
          ] }),
          /* @__PURE__ */ f("div", { className: "bc-theme-manager-label", children: [
            "Theme:",
            /* @__PURE__ */ o("span", { className: "bc-theme-manager-theme-id", children: e.themeId })
          ] }),
          /* @__PURE__ */ o("div", { className: "bc-theme-manager-divider" }),
          /* @__PURE__ */ o(
            "button",
            {
              className: "bc-theme-manager-settings-btn",
              onClick: Te,
              type: "button",
              children: "Settings"
            }
          ),
          /* @__PURE__ */ o("div", { className: "bc-theme-manager-divider" }),
          /* @__PURE__ */ o(
            "button",
            {
              className: "bc-theme-manager-exit-btn",
              onClick: ke,
              type: "button",
              children: "Exit Theme"
            }
          )
        ]
      }
    ),
    k && /* @__PURE__ */ f(
      "div",
      {
        className: "bc-theme-manager-settings-panel",
        style: {
          left: `${a.x}px`,
          top: `${a.y + (((pe = c.current) == null ? void 0 : pe.offsetHeight) || 0) + 8}px`
        },
        children: [
          Z && /* @__PURE__ */ o("div", { className: "bc-theme-manager-message bc-theme-manager-message-success", children: Z }),
          V && /* @__PURE__ */ o("div", { className: "bc-theme-manager-message bc-theme-manager-message-error", children: V }),
          /* @__PURE__ */ f("div", { className: "bc-theme-manager-section", children: [
            /* @__PURE__ */ o("h3", { className: "bc-theme-manager-section-title", children: "Colors" }),
            p && Object.keys(u).length === 0 ? /* @__PURE__ */ o("div", { className: "bc-theme-manager-loading", children: "Loading colors..." }) : /* @__PURE__ */ f("div", { className: "bc-theme-manager-color-list", children: [
              Object.entries(u).map(([s, b]) => /* @__PURE__ */ f("div", { className: "bc-theme-manager-color-row", children: [
                /* @__PURE__ */ o(
                  "input",
                  {
                    type: "text",
                    className: "bc-theme-manager-color-name",
                    value: s,
                    disabled: !0
                  }
                ),
                /* @__PURE__ */ o(
                  "input",
                  {
                    type: "color",
                    className: "bc-theme-manager-color-picker",
                    value: b,
                    onChange: (P) => Se(s, P.target.value),
                    disabled: p
                  }
                ),
                /* @__PURE__ */ o("span", { className: "bc-theme-manager-color-value", children: b }),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-delete-btn",
                    onClick: () => Fe(s),
                    disabled: p,
                    type: "button",
                    children: "Delete"
                  }
                )
              ] }, s)),
              j ? /* @__PURE__ */ f("div", { className: "bc-theme-manager-color-row", children: [
                /* @__PURE__ */ o(
                  "input",
                  {
                    type: "text",
                    className: "bc-theme-manager-color-name",
                    placeholder: "Color name",
                    value: w,
                    onChange: (s) => x(s.target.value),
                    disabled: p
                  }
                ),
                /* @__PURE__ */ o(
                  "input",
                  {
                    type: "color",
                    className: "bc-theme-manager-color-picker",
                    value: N,
                    onChange: (s) => L(s.target.value),
                    disabled: p
                  }
                ),
                /* @__PURE__ */ o("span", { className: "bc-theme-manager-color-value", children: N }),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-save-btn",
                    onClick: Ce,
                    disabled: p || !w.trim(),
                    type: "button",
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-cancel-btn",
                    onClick: () => {
                      d(!1), x(""), L("#000000");
                    },
                    disabled: p,
                    type: "button",
                    children: "Cancel"
                  }
                )
              ] }) : /* @__PURE__ */ o(
                "button",
                {
                  className: "bc-theme-manager-add-color-btn",
                  onClick: () => d(!0),
                  disabled: p,
                  type: "button",
                  children: "+ Add Color"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ f("div", { className: "bc-theme-manager-section", children: [
            /* @__PURE__ */ o("h3", { className: "bc-theme-manager-section-title", children: "Fonts" }),
            /* @__PURE__ */ f("div", { className: "bc-theme-manager-color-list", children: [
              Object.entries(_).map(([s, b]) => /* @__PURE__ */ f("div", { className: "bc-theme-manager-asset-row", children: [
                /* @__PURE__ */ o(
                  "input",
                  {
                    type: "text",
                    className: "bc-theme-manager-asset-name",
                    value: b.name,
                    disabled: !0
                  }
                ),
                /* @__PURE__ */ o("span", { className: "bc-theme-manager-asset-format", children: b.format }),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-delete-btn",
                    onClick: () => Me(s),
                    disabled: p,
                    type: "button",
                    children: "Delete"
                  }
                )
              ] }, s)),
              ae ? /* @__PURE__ */ f("div", { className: "bc-theme-manager-asset-row", children: [
                /* @__PURE__ */ o(
                  "input",
                  {
                    type: "text",
                    className: "bc-theme-manager-asset-name",
                    placeholder: "Font name",
                    value: B,
                    onChange: (s) => m(s.target.value),
                    disabled: p
                  }
                ),
                /* @__PURE__ */ f("div", { className: "bc-theme-manager-file-input-wrapper", children: [
                  /* @__PURE__ */ o(
                    "input",
                    {
                      ref: O,
                      type: "file",
                      accept: ".woff2,.woff,.ttf,.otf",
                      onChange: $e,
                      disabled: p,
                      style: { display: "none" }
                    }
                  ),
                  /* @__PURE__ */ o(
                    "button",
                    {
                      className: "bc-theme-manager-file-btn",
                      onClick: () => {
                        var s;
                        return (s = O.current) == null ? void 0 : s.click();
                      },
                      disabled: p,
                      type: "button",
                      children: S ? "Change" : "Select File"
                    }
                  ),
                  S && /* @__PURE__ */ o("span", { className: "bc-theme-manager-file-name", children: S.name })
                ] }),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-save-btn",
                    onClick: _e,
                    disabled: p || !B.trim() || !S,
                    type: "button",
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-cancel-btn",
                    onClick: () => {
                      X(!1), m(""), q(null), O.current && (O.current.value = "");
                    },
                    disabled: p,
                    type: "button",
                    children: "Cancel"
                  }
                )
              ] }) : /* @__PURE__ */ o(
                "button",
                {
                  className: "bc-theme-manager-add-color-btn",
                  onClick: () => X(!0),
                  disabled: p,
                  type: "button",
                  children: "+ Add Font"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ f("div", { className: "bc-theme-manager-section", children: [
            /* @__PURE__ */ o("h3", { className: "bc-theme-manager-section-title", children: "Icons" }),
            /* @__PURE__ */ f("div", { className: "bc-theme-manager-color-list", children: [
              Object.entries(M).map(([s, b]) => /* @__PURE__ */ f("div", { className: "bc-theme-manager-asset-row", children: [
                /* @__PURE__ */ o("div", { className: "bc-theme-manager-asset-preview", children: /* @__PURE__ */ o("img", { src: b.url, alt: b.name }) }),
                /* @__PURE__ */ o(
                  "input",
                  {
                    type: "text",
                    className: "bc-theme-manager-asset-name",
                    value: b.name,
                    disabled: !0
                  }
                ),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-delete-btn",
                    onClick: () => Pe(s),
                    disabled: p,
                    type: "button",
                    children: "Delete"
                  }
                )
              ] }, s)),
              we ? /* @__PURE__ */ f("div", { className: "bc-theme-manager-asset-row", children: [
                /* @__PURE__ */ o(
                  "input",
                  {
                    type: "text",
                    className: "bc-theme-manager-asset-name",
                    placeholder: "Icon name",
                    value: A,
                    onChange: (s) => ee(s.target.value),
                    disabled: p
                  }
                ),
                /* @__PURE__ */ f("div", { className: "bc-theme-manager-file-input-wrapper", children: [
                  /* @__PURE__ */ o(
                    "input",
                    {
                      ref: H,
                      type: "file",
                      accept: ".svg",
                      onChange: Ne,
                      disabled: p,
                      style: { display: "none" }
                    }
                  ),
                  /* @__PURE__ */ o(
                    "button",
                    {
                      className: "bc-theme-manager-file-btn",
                      onClick: () => {
                        var s;
                        return (s = H.current) == null ? void 0 : s.click();
                      },
                      disabled: p,
                      type: "button",
                      children: D ? "Change" : "Select SVG"
                    }
                  ),
                  D && /* @__PURE__ */ o("span", { className: "bc-theme-manager-file-name", children: D.name })
                ] }),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-save-btn",
                    onClick: Ee,
                    disabled: p || !A.trim() || !D,
                    type: "button",
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "bc-theme-manager-cancel-btn",
                    onClick: () => {
                      oe(!1), ee(""), re(null), H.current && (H.current.value = "");
                    },
                    disabled: p,
                    type: "button",
                    children: "Cancel"
                  }
                )
              ] }) : /* @__PURE__ */ o(
                "button",
                {
                  className: "bc-theme-manager-add-color-btn",
                  onClick: () => oe(!0),
                  disabled: p,
                  type: "button",
                  children: "+ Add Icon"
                }
              )
            ] })
          ] })
        ]
      }
    )
  ] });
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ge = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Qe = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (a, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), be = (e) => {
  const a = Qe(e);
  return a.charAt(0).toUpperCase() + a.slice(1);
}, ye = (...e) => e.filter((a, n, r) => !!a && a.trim() !== "" && r.indexOf(a) === n).join(" ").trim(), Ze = (e) => {
  for (const a in e)
    if (a.startsWith("aria-") || a === "role" || a === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var et = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tt = fe(
  ({
    color: e = "currentColor",
    size: a = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: l,
    iconNode: h,
    ...c
  }, k) => le(
    "svg",
    {
      ref: k,
      ...et,
      width: a,
      height: a,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(a) : n,
      className: ye("lucide", i),
      ...!l && !Ze(c) && { "aria-hidden": "true" },
      ...c
    },
    [
      ...h.map(([g, u]) => le(g, u)),
      ...Array.isArray(l) ? l : [l]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const at = (e, a) => {
  const n = fe(
    ({ className: r, ...i }, l) => le(tt, {
      ref: l,
      iconNode: a,
      className: ye(
        `lucide-${Ge(be(e))}`,
        `lucide-${e}`,
        r
      ),
      ...i
    })
  );
  return n.displayName = be(e), n;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ot = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], rt = at("settings", ot), nt = ({
  fields: e,
  values: a,
  onChange: n,
  onClose: r,
  screenPosition: i,
  onSave: l,
  isSaving: h = !1,
  themeColors: c = {},
  themeFonts: k = {},
  themeIcons: g = {}
}) => {
  const [u, I] = v({ x: 0, y: 0 }), [_, $] = v(!1), M = U(null), y = U({ x: 0, y: 0 }), [w, x] = v({}), N = (d) => {
    $(!0), y.current = {
      x: d.clientX - u.x,
      y: d.clientY - u.y
    };
  };
  ie(() => {
    const d = (F) => {
      _ && I({
        x: F.clientX - y.current.x,
        y: F.clientY - y.current.y
      });
    }, p = () => {
      $(!1);
    };
    return _ && (document.addEventListener("mousemove", d), document.addEventListener("mouseup", p)), () => {
      document.removeEventListener("mousemove", d), document.removeEventListener("mouseup", p);
    };
  }, [_]);
  const L = (d) => {
    var F, V;
    const p = a[d.key];
    switch (d.type) {
      case "text":
        return /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            value: p || "",
            onChange: (m) => n(d.key, m.target.value),
            className: "edit-panel-input",
            style: {
              width: "100%",
              padding: "12px 14px",
              border: `1px solid ${t.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: t.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: t.white,
              outline: "none"
            }
          }
        );
      case "options":
        return /* @__PURE__ */ o(
          "select",
          {
            value: p ?? ((V = (F = d.options) == null ? void 0 : F[0]) == null ? void 0 : V.value) ?? "",
            onChange: (m) => n(d.key, m.target.value),
            className: "edit-panel-select",
            style: {
              width: "100%",
              padding: "12px 14px",
              border: `1px solid ${t.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: t.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: t.white,
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 12px center",
              paddingRight: "36px"
            },
            children: (d.options ?? []).map((m) => /* @__PURE__ */ o("option", { value: m.value, children: m.label }, m.value))
          }
        );
      case "color":
        const Z = (() => {
          if (w[d.key])
            return w[d.key];
          const m = (p || "").toLowerCase();
          for (const [S, q] of Object.entries(c))
            if (q.toLowerCase() === m)
              return S;
          return "";
        })(), T = (m) => {
          x((S) => ({
            ...S,
            [d.key]: m
          })), m && c[m] && n(d.key, c[m]);
        }, ae = (m) => {
          x((S) => ({
            ...S,
            [d.key]: ""
          })), n(d.key, m);
        }, X = (m) => {
          x((S) => ({
            ...S,
            [d.key]: ""
          })), n(d.key, m);
        };
        return /* @__PURE__ */ f(
          "div",
          {
            style: {
              display: "flex",
              gap: "10px",
              alignItems: "center"
            },
            children: [
              /* @__PURE__ */ o(
                "input",
                {
                  type: "color",
                  value: p || "#000000",
                  onChange: (m) => ae(m.target.value),
                  className: "edit-panel-color-picker",
                  style: {
                    width: "48px",
                    height: "42px",
                    border: `2px solid ${t.border_glass}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    padding: "3px",
                    transition: "all 0.15s ease"
                  }
                }
              ),
              /* @__PURE__ */ f(
                "select",
                {
                  value: Z,
                  onChange: (m) => T(m.target.value),
                  className: "edit-panel-select",
                  style: {
                    flex: 1,
                    padding: "12px 14px",
                    border: `1px solid ${t.border_glass}`,
                    borderRadius: "10px",
                    fontSize: "13px",
                    color: t.primary,
                    boxSizing: "border-box",
                    transition: "all 0.15s ease",
                    background: t.white,
                    cursor: "pointer",
                    maxWidth: "110px",
                    outline: "none",
                    appearance: "none",
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 10px center",
                    paddingRight: "30px"
                  },
                  children: [
                    /* @__PURE__ */ o("option", { value: "", children: "Custom" }),
                    Object.keys(c).map((m) => /* @__PURE__ */ o("option", { value: m, children: m }, m))
                  ]
                }
              ),
              /* @__PURE__ */ o(
                "input",
                {
                  type: "text",
                  value: p || "#000000",
                  onChange: (m) => X(m.target.value),
                  placeholder: "#000000",
                  className: "edit-panel-color-text",
                  style: {
                    width: "100px",
                    padding: "12px 10px",
                    border: `1px solid ${t.border_glass}`,
                    borderRadius: "10px",
                    fontSize: "12px",
                    color: t.primary,
                    fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace",
                    background: t.bg_light,
                    outline: "none",
                    transition: "all 0.15s ease"
                  }
                }
              )
            ]
          }
        );
      case "number":
        return /* @__PURE__ */ o(
          "input",
          {
            type: "number",
            value: p || 0,
            min: d.min,
            max: d.max,
            step: d.step || 1,
            onChange: (m) => n(d.key, parseFloat(m.target.value)),
            className: "edit-panel-input",
            style: {
              width: "100%",
              padding: "12px 14px",
              border: `1px solid ${t.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: t.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: t.white,
              outline: "none"
            }
          }
        );
      case "toggle":
        const B = !!p;
        return /* @__PURE__ */ o(
          "button",
          {
            type: "button",
            role: "switch",
            "aria-checked": B,
            onClick: () => n(d.key, !B),
            className: "edit-panel-toggle",
            style: {
              width: "48px",
              height: "28px",
              borderRadius: "14px",
              border: "none",
              padding: "2px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              background: B ? t.blue : t.gray_light,
              display: "flex",
              alignItems: "center",
              justifyContent: B ? "flex-end" : "flex-start"
            },
            children: /* @__PURE__ */ o(
              "span",
              {
                style: {
                  width: "24px",
                  height: "24px",
                  borderRadius: "12px",
                  background: t.white,
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
                  transition: "all 0.2s ease"
                }
              }
            )
          }
        );
      case "font":
        return /* @__PURE__ */ f(
          "select",
          {
            value: p || "inherit",
            onChange: (m) => n(d.key, m.target.value),
            className: "edit-panel-select",
            style: {
              width: "100%",
              padding: "12px 14px",
              border: `1px solid ${t.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: t.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: t.white,
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 12px center",
              paddingRight: "36px"
            },
            children: [
              /* @__PURE__ */ o("option", { value: "inherit", children: "Inherit (System Font)" }),
              Object.entries(k).map(([m, S]) => /* @__PURE__ */ o("option", { value: m, children: S.name }, m))
            ]
          }
        );
      case "icon":
        return /* @__PURE__ */ f(
          "select",
          {
            value: p || "default",
            onChange: (m) => n(d.key, m.target.value),
            className: "edit-panel-select",
            style: {
              width: "100%",
              padding: "12px 14px",
              border: `1px solid ${t.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: t.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: t.white,
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 12px center",
              paddingRight: "36px"
            },
            children: [
              /* @__PURE__ */ o("option", { value: "default", children: "Default" }),
              Object.entries(g).map(([m, S]) => /* @__PURE__ */ o("option", { value: m, children: S.name }, m))
            ]
          }
        );
      default:
        return null;
    }
  }, j = /* @__PURE__ */ f(E, { children: [
    /* @__PURE__ */ o("style", { children: `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .edit-panel-close {
          transition: all 0.15s ease;
        }

        .edit-panel-close:hover {
          background-color: ${t.overlay_light};
          color: ${t.primary};
          transform: scale(1.1);
        }

        .edit-panel-input:focus,
        .edit-panel-select:focus {
          border-color: ${t.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
        }

        .edit-panel-input:hover:not(:focus),
        .edit-panel-select:hover:not(:focus) {
          border-color: ${t.gray_border};
        }

        .edit-panel-color-text:focus {
          border-color: ${t.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${t.white};
        }

        .edit-panel-color-picker:hover {
          border-color: ${t.gray_border};
          transform: scale(1.05);
        }

        .drag-handle {
          cursor: ${_ ? "grabbing" : "grab"};
          transition: background-color 0.15s ease;
        }

        .drag-handle:hover {
          background-color: ${t.overlay_light};
        }

        .edit-panel-save-button {
          background: linear-gradient(135deg, ${t.blue} 0%, ${t.blue_dark} 100%);
          color: ${t.white};
          border: none;
          padding: 10px 18px;
          border-radius: 10px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.15s ease;
          box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
          letter-spacing: 0.3px;
        }

        .edit-panel-save-button:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
        }

        .edit-panel-save-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .edit-panel-save-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* Custom scrollbar */
        .edit-panel-content::-webkit-scrollbar {
          width: 6px;
        }

        .edit-panel-content::-webkit-scrollbar-track {
          background: transparent;
        }

        .edit-panel-content::-webkit-scrollbar-thumb {
          background: ${t.gray_border};
          border-radius: 3px;
        }

        .edit-panel-content::-webkit-scrollbar-thumb:hover {
          background: ${t.gray_medium};
        }
      ` }),
    /* @__PURE__ */ f(
      "div",
      {
        ref: M,
        style: {
          position: "fixed",
          top: i.y + u.y,
          left: i.x + u.x,
          background: t.glass_bg_strong,
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: `1px solid ${t.border_subtle}`,
          borderRadius: "20px",
          boxShadow: `
            0 8px 40px ${t.shadow_medium},
            0 20px 60px ${t.shadow_soft},
            0 0 0 1px ${t.border_glass}
          `,
          zIndex: 999999,
          width: "620px",
          maxWidth: "620px",
          maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          animation: "edit-panel-slideIn 0.2s ease-out"
        },
        onClick: (d) => d.stopPropagation(),
        onMouseDown: (d) => d.stopPropagation(),
        children: [
          /* @__PURE__ */ f(
            "div",
            {
              className: "drag-handle",
              onMouseDown: N,
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                borderBottom: `1px solid ${t.border_glass}`,
                borderRadius: "20px 20px 0 0",
                userSelect: "none"
              },
              children: [
                /* @__PURE__ */ f(
                  "div",
                  {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      flex: 1
                    },
                    children: [
                      /* @__PURE__ */ o(
                        "div",
                        {
                          style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "3px",
                            opacity: 0.3
                          },
                          children: [...Array(6)].map((d, p) => /* @__PURE__ */ o(
                            "div",
                            {
                              style: {
                                width: "4px",
                                height: "4px",
                                background: t.gray_medium,
                                borderRadius: "1px"
                              }
                            },
                            p
                          ))
                        }
                      ),
                      /* @__PURE__ */ o(
                        "h3",
                        {
                          style: {
                            fontSize: "13px",
                            fontWeight: 600,
                            color: t.primary,
                            margin: 0,
                            letterSpacing: "0.2px"
                          },
                          children: "Edit Properties"
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ f("div", { style: { display: "flex", gap: "12px", alignItems: "center" }, children: [
                  l && /* @__PURE__ */ o(
                    "button",
                    {
                      onClick: l,
                      disabled: h,
                      className: "edit-panel-save-button",
                      "aria-label": "Save changes",
                      type: "submit",
                      children: h ? "Saving..." : "Save"
                    }
                  ),
                  /* @__PURE__ */ o(
                    "button",
                    {
                      onClick: r,
                      "aria-label": "Close",
                      className: "edit-panel-close",
                      style: {
                        background: t.overlay_light,
                        border: "none",
                        fontSize: "18px",
                        cursor: "pointer",
                        color: t.gray_medium,
                        padding: 0,
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "10px",
                        fontWeight: 400
                      },
                      children: "✕"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ o(
            "div",
            {
              className: "edit-panel-content",
              style: {
                padding: "20px 24px 24px",
                overflowY: "auto",
                overflowX: "hidden",
                flex: 1
              },
              children: /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "20px"
                  },
                  children: e.map((d) => /* @__PURE__ */ f(
                    "div",
                    {
                      style: {
                        minWidth: 0
                      },
                      children: [
                        /* @__PURE__ */ o(
                          "label",
                          {
                            style: {
                              display: "block",
                              fontSize: "11px",
                              fontWeight: 600,
                              color: t.gray_medium,
                              marginBottom: "8px",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px"
                            },
                            children: d.label
                          }
                        ),
                        L(d)
                      ]
                    },
                    d.key
                  ))
                }
              )
            }
          )
        ]
      }
    )
  ] });
  return Re.createPortal(j, document.body);
}, it = () => R().editMode, Q = ({
  children: e,
  editFields: a,
  editValues: n,
  onEditChange: r,
  onSave: i,
  isSaving: l = !1,
  themeColors: h = {},
  themeFonts: c = {},
  themeIcons: k = {}
}) => {
  const [g, u] = v(!1), [I, _] = v({ x: 0, y: 0 }), $ = U(null);
  if (!it())
    return /* @__PURE__ */ o(E, { children: e });
  const y = () => {
    if ($.current) {
      const w = $.current.getBoundingClientRect();
      _({
        x: w.left,
        y: w.bottom + 10
      });
    }
    u(!0);
  };
  return /* @__PURE__ */ f(E, { children: [
    /* @__PURE__ */ o("style", { children: `
        .widget-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
          outline: 1px dashed #ff7070;
        }

        .widget-wrapper:hover {
          outline: 1px dashed #f00;
        }

        .widget-setting-icon {
          position: absolute;
          top: 0px;
          right: 0px;
          width: 32px;
          height: 32px;
          background: ${t.white};
          border: 1px solid ${t.gray_border};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transition: all 0.2s;
          z-index: 10;
          padding: 0;
          opacity: 0;
        }

        .widget-wrapper:hover .widget-setting-icon {
          opacity: 1;
        }

        .widget-setting-icon:hover {
          background: ${t.blue_light};
          border-color: ${t.blue};
          transform: rotate(30deg);
        }
      ` }),
    /* @__PURE__ */ f("div", { className: "widget-wrapper", children: [
      /* @__PURE__ */ o(
        "button",
        {
          ref: $,
          className: "widget-setting-icon",
          onClick: (w) => {
            w.stopPropagation(), w.preventDefault(), y();
          },
          "aria-label": "Edit widget",
          children: /* @__PURE__ */ o(rt, { size: 18, color: t.gray_dark })
        }
      ),
      e,
      g && /* @__PURE__ */ o(
        nt,
        {
          fields: a,
          values: n,
          onChange: r,
          onClose: () => u(!1),
          screenPosition: I,
          onSave: i,
          isSaving: l,
          themeColors: h,
          themeFonts: c,
          themeIcons: k
        }
      )
    ] })
  ] });
}, lt = {
  content: "Default Text",
  fontFamily: "inherit",
  fontFamilyOverride: !1,
  fontSize: 16,
  fontWeight: "normal",
  color: "#181d56",
  textAlign: "left",
  lineHeight: 1.5,
  letterSpacing: 0,
  textTransform: "none"
}, st = [
  { key: "content", label: "Text Content", type: "text" },
  { key: "fontFamily", label: "Font Family", type: "font" },
  { key: "fontFamilyOverride", label: "Override Font (!important)", type: "toggle" },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 72,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  { key: "color", label: "Text Color", type: "color" },
  {
    key: "textAlign",
    label: "Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 3,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  }
], Tt = ({
  initialState: e = {},
  widgetId: a
}) => {
  const { isLoading: n, ...r } = J(a, {
    ...lt,
    ...e
  }), i = r, [l, h] = v(!1), { themeColors: c } = Y(), { themeFonts: k } = de(), g = R(), { updateWidgetConfig: u, getWidgetState: I } = G(a), _ = (d, p) => {
    u(d, p);
  }, $ = async () => {
    if (!g.themeId || !g.editThemeToken || !a) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    h(!0);
    try {
      const d = I() || i;
      await K({
        themeId: g.themeId,
        widgetId: a,
        widgetState: d,
        editThemeToken: g.editThemeToken
      }), alert("Saved successfully!");
    } catch (d) {
      console.error("Failed to save widget config:", d), alert(`Failed to save: ${d.message}`);
    } finally {
      h(!1);
    }
  };
  if (n)
    return /* @__PURE__ */ o(E, {});
  const M = (d) => ({
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  })[d] || 400, y = i.fontFamily, w = y && y !== "inherit" ? k[y] : null, x = w ? `"${w.name}", sans-serif` : "inherit", N = `textbox-${a || "default"}`, L = `
    ${w ? `
      @font-face {
        font-family: "${w.name}";
        src: url("${w.url}") format("${w.format}");
        font-display: swap;
      }
    ` : ""}
    ${i.fontFamilyOverride && x !== "inherit" ? `.${N} { font-family: ${x} !important; }` : ""}
  `.trim(), j = /* @__PURE__ */ f(E, { children: [
    L && /* @__PURE__ */ o("style", { children: L }),
    /* @__PURE__ */ o(
      "span",
      {
        className: `textbox-content ${N}`,
        style: {
          // Only set font-family inline if NOT using override (to avoid duplicate declarations)
          ...i.fontFamilyOverride ? {} : { fontFamily: x },
          fontSize: `${i.fontSize}px`,
          fontWeight: M(i.fontWeight),
          color: i.color,
          textAlign: i.textAlign,
          lineHeight: i.lineHeight,
          letterSpacing: `${i.letterSpacing}px`,
          textTransform: i.textTransform,
          display: "inline-block",
          width: "100%"
        },
        children: i.content
      }
    )
  ] });
  return a ? /* @__PURE__ */ o(
    Q,
    {
      editFields: st,
      editValues: i,
      onEditChange: _,
      onSave: g.themeId && g.editThemeToken ? $ : void 0,
      isSaving: l,
      themeColors: c,
      themeFonts: k,
      children: j
    }
  ) : j;
}, dt = {
  // Border styling
  borderColor: "#DCDDDC",
  borderColorFocus: "#DCDDDC",
  borderRadiusSingleLine: 100,
  // pill shape
  borderRadiusMultiLine: 20,
  // rounded
  borderWidth: 1,
  // Submit button
  submitButtonBgColor: "#000000",
  submitButtonBgColorHover: "#333333",
  submitButtonIconColor: "#FFFFFF",
  submitButtonSize: 24,
  submitButtonBorderRadius: 14,
  // Action icons (attachment, mic)
  iconColor: "#000000",
  iconColorHover: "#333333",
  iconSize: 24,
  micActiveColor: "#EF4444",
  microphoneIcon: "default",
  // Textarea typography
  fontSize: 16,
  fontWeight: "normal",
  textColor: "#000000",
  placeholderColor: "#9CA3AF",
  // Layout
  paddingX: 12,
  paddingY: 12,
  maxWidth: 768,
  // Visibility toggles
  showAttachmentButton: !0,
  showMicrophoneButton: !0
}, ct = [
  // Border styling group
  { key: "borderColor", label: "Border Color", type: "color" },
  { key: "borderColorFocus", label: "Border Color (Focus)", type: "color" },
  {
    key: "borderRadiusSingleLine",
    label: "Border Radius (Single Line)",
    type: "number",
    min: 0,
    max: 100,
    step: 1
  },
  {
    key: "borderRadiusMultiLine",
    label: "Border Radius (Multi Line)",
    type: "number",
    min: 0,
    max: 50,
    step: 1
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 1
  },
  // Submit button group
  { key: "submitButtonBgColor", label: "Submit Button Color", type: "color" },
  {
    key: "submitButtonBgColorHover",
    label: "Submit Button Hover Color",
    type: "color"
  },
  {
    key: "submitButtonIconColor",
    label: "Submit Button Icon Color",
    type: "color"
  },
  {
    key: "submitButtonSize",
    label: "Submit Button Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "submitButtonBorderRadius",
    label: "Submit Button Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  // Action icons group
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "iconColorHover", label: "Icon Hover Color", type: "color" },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  { key: "micActiveColor", label: "Mic Active Color", type: "color" },
  { key: "microphoneIcon", label: "Microphone Icon", type: "icon" },
  // Typography group
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "placeholderColor", label: "Placeholder Color", type: "color" },
  // Layout group
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 1200,
    step: 50
  },
  // Visibility toggles
  {
    key: "showAttachmentButton",
    label: "Show Attachment Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  },
  {
    key: "showMicrophoneButton",
    label: "Show Microphone Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  }
], Ct = ({
  initialState: e = {},
  widgetId: a,
  children: n
}) => {
  const { isLoading: r, ...i } = J(
    a,
    { ...dt, ...e }
  ), l = i, [h, c] = v(!1), { themeColors: k } = Y(), { themeIcons: g } = xe(), u = R(), { updateWidgetConfig: I, getWidgetState: _ } = G(a), $ = (x, N) => {
    x === "showAttachmentButton" || x === "showMicrophoneButton" ? I(x, N === "true") : I(x, N);
  }, M = async () => {
    if (!u.themeId || !u.editThemeToken || !a) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    c(!0);
    try {
      const x = _() || l;
      await K({
        themeId: u.themeId,
        widgetId: a,
        widgetState: x,
        editThemeToken: u.editThemeToken
      }), alert("Saved successfully!");
    } catch (x) {
      console.error("Failed to save widget config:", x), alert(`Failed to save: ${x.message}`);
    } finally {
      c(!1);
    }
  }, y = () => ({
    ...l,
    showAttachmentButton: l.showAttachmentButton ? "true" : "false",
    showMicrophoneButton: l.showMicrophoneButton ? "true" : "false"
  });
  if (r)
    return /* @__PURE__ */ o(E, {});
  const w = n(l, g);
  return a ? /* @__PURE__ */ o(
    Q,
    {
      editFields: ct,
      editValues: y(),
      onEditChange: $,
      onSave: u.themeId && u.editThemeToken ? M : void 0,
      isSaving: h,
      themeColors: k,
      themeIcons: g,
      children: w
    }
  ) : /* @__PURE__ */ o(E, { children: w });
}, mt = {
  // Pill styling
  pillBgColor: t.gray_light,
  pillBgColorHover: t.gray_border,
  pillTextColor: t.primary,
  pillFontSize: 12,
  pillFontWeight: "500",
  pillBorderRadius: 8,
  pillPaddingX: 12,
  pillPaddingY: 6,
  // Container
  containerGap: 8,
  maxWidthDesktop: "80%",
  maxWidthMobile: "100%"
}, pt = [
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "400" },
      { label: "Medium", value: "500" },
      { label: "Semibold", value: "600" },
      { label: "Bold", value: "700" }
    ]
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "pillPaddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 2,
    max: 16,
    step: 2
  },
  {
    key: "containerGap",
    label: "Gap Between Pills (px)",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "maxWidthDesktop",
    label: "Max Width (Desktop)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "maxWidthMobile",
    label: "Max Width (Mobile)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" }
    ]
  }
], St = ({
  initialState: e = {},
  widgetId: a,
  children: n
}) => {
  const { isLoading: r, ...i } = J(a, {
    ...mt,
    ...e
  }), l = i, [h, c] = v(!1), { themeColors: k } = Y(), g = R(), { updateWidgetConfig: u, getWidgetState: I } = G(a), _ = (y, w) => {
    u(y, w);
  }, $ = async () => {
    if (!g.themeId || !g.editThemeToken || !a) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    c(!0);
    try {
      const y = I() || l;
      await K({
        themeId: g.themeId,
        widgetId: a,
        widgetState: y,
        editThemeToken: g.editThemeToken
      }), alert("Saved successfully!");
    } catch (y) {
      console.error("Failed to save widget config:", y), alert(`Failed to save: ${y.message}`);
    } finally {
      c(!1);
    }
  };
  if (r)
    return /* @__PURE__ */ o(E, {});
  const M = n(l);
  return a ? /* @__PURE__ */ o(
    Q,
    {
      editFields: pt,
      editValues: l,
      onEditChange: _,
      onSave: g.themeId && g.editThemeToken ? $ : void 0,
      isSaving: h,
      themeColors: k,
      children: M
    }
  ) : /* @__PURE__ */ o(E, { children: M });
}, ht = {
  // Background & Colors (defaults for user message, assistant can override via widgetId)
  bgColor: "#E8F4FD",
  // blueWhite-like for user
  textColor: t.primary,
  // Border radius
  borderRadius: 10,
  borderRadiusShort: 100,
  // pill shape for short messages
  // Typography
  fontSize: 14,
  fontWeight: "400",
  lineHeight: 1.5,
  // Padding
  paddingX: 16,
  paddingY: 12,
  // Layout
  maxWidth: "70%",
  // Short message threshold
  shortMessageThreshold: 50
}, gt = [
  { key: "bgColor", label: "Background Color", type: "color" },
  { key: "textColor", label: "Text Color", type: "color" },
  {
    key: "borderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "borderRadiusShort",
    label: "Short Msg Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "400" },
      { label: "Medium", value: "500" },
      { label: "Semibold", value: "600" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "paddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "shortMessageThreshold",
    label: "Short Msg Threshold (chars)",
    type: "number",
    min: 20,
    max: 100,
    step: 10
  }
], Ft = ({
  initialState: e = {},
  widgetId: a,
  children: n
}) => {
  const { isLoading: r, ...i } = J(a, {
    ...ht,
    ...e
  }), l = i, [h, c] = v(!1), { themeColors: k } = Y(), g = R(), { updateWidgetConfig: u, getWidgetState: I } = G(a), _ = (y, w) => {
    u(y, w);
  }, $ = async () => {
    if (!g.themeId || !g.editThemeToken || !a) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    c(!0);
    try {
      const y = I() || l;
      await K({
        themeId: g.themeId,
        widgetId: a,
        widgetState: y,
        editThemeToken: g.editThemeToken
      }), alert("Saved successfully!");
    } catch (y) {
      console.error("Failed to save widget config:", y), alert(`Failed to save: ${y.message}`);
    } finally {
      c(!1);
    }
  };
  if (r)
    return /* @__PURE__ */ o(E, {});
  const M = n(l);
  return a ? /* @__PURE__ */ o(
    Q,
    {
      editFields: gt,
      editValues: l,
      onEditChange: _,
      onSave: g.themeId && g.editThemeToken ? $ : void 0,
      isSaving: h,
      themeColors: k,
      children: M
    }
  ) : /* @__PURE__ */ o(E, { children: M });
}, ut = {
  // Card container
  cardBorderColor: "#dcdddc",
  cardBorderRadius: 12,
  cardBgColor: "transparent",
  cardBgColorHover: "#F6F8FA",
  cardPadding: 16,
  cardPaddingMobile: 10,
  // Title
  titleColor: "#181D56",
  titleFontFamily: "inherit",
  titleFontSize: 14,
  titleFontWeight: 500,
  titleLineClamp: 3,
  titleLineHeight: 1.5,
  titleMarginTop: 20,
  // Price
  priceColor: "#181D56",
  priceFontSize: 20,
  priceFontSizeMobile: 16,
  priceFontWeight: 600,
  // Retailer icons
  retailerIconSize: 25,
  retailerIconSizeMobile: 15,
  // Image container
  imageMaxWidth: 190
}, bt = [
  // Card container
  { key: "cardBorderColor", label: "Card Border Color", type: "color" },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  { key: "cardBgColor", label: "Card Background", type: "color" },
  { key: "cardBgColorHover", label: "Card Hover Background", type: "color" },
  {
    key: "cardPadding",
    label: "Card Padding (Desktop)",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  {
    key: "cardPaddingMobile",
    label: "Card Padding (Mobile)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  { key: "titleFontFamily", label: "Title Font Family", type: "font" },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "400" },
      { label: "Medium", value: "500" },
      { label: "Semibold", value: "600" },
      { label: "Bold", value: "700" }
    ]
  },
  {
    key: "titleLineClamp",
    label: "Title Line Clamp",
    type: "number",
    min: 1,
    max: 5,
    step: 1
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "titleMarginTop",
    label: "Title Margin Top (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size (Desktop)",
    type: "number",
    min: 14,
    max: 28,
    step: 1
  },
  {
    key: "priceFontSizeMobile",
    label: "Price Font Size (Mobile)",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [
      { label: "Medium", value: "500" },
      { label: "Semibold", value: "600" },
      { label: "Bold", value: "700" }
    ]
  },
  // Retailer icons
  {
    key: "retailerIconSize",
    label: "Retailer Icon Size (Desktop)",
    type: "number",
    min: 16,
    max: 40,
    step: 1
  },
  {
    key: "retailerIconSizeMobile",
    label: "Retailer Icon Size (Mobile)",
    type: "number",
    min: 12,
    max: 30,
    step: 1
  },
  // Image
  {
    key: "imageMaxWidth",
    label: "Image Max Width (px)",
    type: "number",
    min: 120,
    max: 250,
    step: 10
  }
], It = ({
  initialState: e = {},
  widgetId: a,
  children: n
}) => {
  const { isLoading: r, ...i } = J(
    a,
    { ...ut, ...e }
  ), l = i, [h, c] = v(!1), { themeColors: k } = Y(), { themeFonts: g } = de(), u = R(), { updateWidgetConfig: I, getWidgetState: _ } = G(a), $ = (x, N) => {
    x === "titleFontWeight" || x === "priceFontWeight" ? I(x, parseInt(N, 10)) : I(x, N);
  }, M = async () => {
    if (!u.themeId || !u.editThemeToken || !a) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    c(!0);
    try {
      const x = _() || l;
      await K({
        themeId: u.themeId,
        widgetId: a,
        widgetState: x,
        editThemeToken: u.editThemeToken
      }), alert("Saved successfully!");
    } catch (x) {
      console.error("Failed to save widget config:", x), alert(`Failed to save: ${x.message}`);
    } finally {
      c(!1);
    }
  }, y = () => ({
    ...l,
    titleFontWeight: String(l.titleFontWeight),
    priceFontWeight: String(l.priceFontWeight)
  });
  if (r)
    return /* @__PURE__ */ o(E, {});
  const w = n(l, g);
  return a ? /* @__PURE__ */ o(
    Q,
    {
      editFields: bt,
      editValues: y(),
      onEditChange: $,
      onSave: u.themeId && u.editThemeToken ? M : void 0,
      isSaving: h,
      themeColors: k,
      themeFonts: g,
      children: w
    }
  ) : /* @__PURE__ */ o(E, { children: w });
};
export {
  Ct as ChatInput,
  nt as EditPanel,
  St as FollowUpQueriesWidget,
  Ft as MessageBubbleWidget,
  It as ProductCardWidget,
  Tt as TextBox,
  kt as ThemeManager,
  se as WIDGET_THEME_QUERY_KEY,
  Q as WidgetWrapper,
  je as clearThemeParams,
  Ae as clearUrlParams,
  t as colors,
  De as getThemeParams,
  Le as saveThemeParams,
  Oe as syncUrlToStorage,
  vt as updateUrlParams,
  it as useEditMode,
  Y as useThemeColors,
  de as useThemeFonts,
  xe as useThemeIcons,
  J as useWidgetConfig,
  G as useWidgetEdit,
  te as useWidgetTheme,
  R as useWidgetThemeParams
};
//# sourceMappingURL=index.js.map
